import { Utm } from '@/types/utm';

const UTM_SESSION_STORAGE_KEY = 'utm_session_storage_key';

const UTM_PREFIX = 'utm_';

export const saveUtmToSessionStorage = (location: string) => {
	if (typeof window === 'undefined') {
		return;
	}

	const utm = extractUtm(location);

	if (hasUtm(utm)) {
		window.sessionStorage.setItem(UTM_SESSION_STORAGE_KEY, JSON.stringify(utm));
	}
};

export const getUtmFromSessionStorage = (): Utm => {
	if (typeof window === 'undefined') {
		return {};
	}

	const storageValue = window.sessionStorage.getItem(UTM_SESSION_STORAGE_KEY);

	if (!storageValue) {
		return {};
	}

	try {
		const parsedValue = JSON.parse(storageValue);

		return parsedValue && typeof parsedValue === 'object' ? parsedValue : {};
	} catch {
		return {};
	}
};

export const getCurrentSessionUtm = (location?: string) => {
	const currentUrlUtm = location ? extractUtm(location) : {};

	if (hasUtm(currentUrlUtm)) {
		return currentUrlUtm;
	}

	return getUtmFromSessionStorage();
};

const getUrlSearchParams = (location: string) => {
	const baseUrl = window.location.origin;

	return new URL(location, baseUrl).searchParams;
};

const extractUtm = (location: string) => {
	const params = getUrlSearchParams(location);
	const utm: Utm = {};

	params.forEach((value, key) => {
		if (key.toLowerCase().startsWith(UTM_PREFIX) && value) {
			utm[key] = value;
		}
	});

	return utm;
};

const hasUtm = (utm: Utm) => Object.keys(utm).length > 0;
